import request from "@/util/http"; // 获取学期

export var getSemesterSel = function getSemesterSel(params) {
  return request({
    url: "/hq/kb/semester",
    method: "get",
    params: params
  });
}; //获取学期周次

export var getWeekSel = function getWeekSel(params) {
  return request({
    url: "/hq/kb/semesterWeek",
    method: "get",
    params: params
  });
}; //获取教师列表

export var getTeaSel = function getTeaSel(params) {
  return request({
    url: "/hq/kb/teacherList",
    method: "get",
    params: params
  });
}; //获取教师课表

export var getTeaTimeTab = function getTeaTimeTab(params) {
  return request({
    url: "/hq/kb/teacherKbInfo",
    method: "get",
    params: params
  });
};
export var getTeaTimeTab_new = function getTeaTimeTab_new(params) {
  return request({
    url: "/hq/kb/newTeacherKbInfo",
    method: "get",
    params: params
  });
}; //获取课表节次

export var getTimeTabWeek = function getTimeTabWeek(params) {
  return request({
    url: "/hq/kb/jcConfig",
    method: "get",
    params: params
  });
};
export var getClassList = function getClassList(params) {
  return request({
    url: "/hq/kb/classList",
    method: "get",
    params: params
  });
}; //获取班级课表

export var getClassTimeTab = function getClassTimeTab(params) {
  return request({
    url: "/hq/kb/classKbInfo",
    method: "get",
    params: params
  });
};
export var getClassTimeTab_new = function getClassTimeTab_new(params) {
  return request({
    url: "/hq/kb/newClassKbInfo",
    method: "get",
    params: params
  });
};
export var getClassRoomList = function getClassRoomList(params) {
  return request({
    url: "/hq/kb/classRoomList",
    method: "get",
    params: params
  });
};
export var getClassRoomKbInfo = function getClassRoomKbInfo(params) {
  return request({
    url: "/hq/kb/classRoomKbInfo",
    method: "get",
    params: params
  });
};
export var getClassRoomKbInfo_new = function getClassRoomKbInfo_new(params) {
  return request({
    url: "/hq/kb/newClassRoomKbInfo",
    method: "get",
    params: params
  });
}; //获取班级课表

export var getMyKbTimeTab = function getMyKbTimeTab(params) {
  return request({
    url: "/hq/kb/myKbInfo",
    method: "get",
    params: params
  });
};
export var getNewMyKbTimeTab = function getNewMyKbTimeTab(params) {
  return request({
    url: "/hq/kb/newMyKbInfo",
    method: "get",
    params: params
  });
}; //评教查询

export var selectPCAttendance = function selectPCAttendance(params) {
  return request({
    url: "/hq/attendance/selectPCAttendance",
    method: "get",
    params: params
  });
}; //获取基本信息

export var selectKbDetails = function selectKbDetails(params) {
  return request({
    url: "/hq/attendance/selectKbDetails",
    method: "post",
    data: params
  });
}; //获取评教详情

export var selectEvaluaDetails = function selectEvaluaDetails(params) {
  return request({
    url: "/hq/evalua/selectEvaluaDetails",
    method: "post",
    data: params
  });
}; //评教详情课堂评分分页

export var selectEvaluaScorePage = function selectEvaluaScorePage(params) {
  return request({
    url: "/hq/evalua/selectEvaluaScorePage",
    method: "get",
    params: params
  });
}; //获取考勤详情

export var selectAttendanceDetails = function selectAttendanceDetails(params) {
  return request({
    url: "/hq/attendance/selectAttendanceDetails",
    method: "post",
    params: params
  });
}; //获取考勤详情分页

export var selectPCAttendanceStuPage = function selectPCAttendanceStuPage(params) {
  return request({
    url: "/hq/attendance/selectPCAttendanceStuPage",
    method: "get",
    params: params
  });
}; //设置学生考勤状态

export var setClassOverviewPC = function setClassOverviewPC(params) {
  return request({
    url: "/hq/attendance/setClassOverviewPC",
    method: "post",
    data: params
  });
}; //考勤补签分页

export var getSupList = function getSupList(params) {
  return request({
    url: "/hq/attendance/getMakeUpPage",
    method: "get",
    params: params
  });
}; //考勤补签审批

export var setSupStatus = function setSupStatus(params) {
  return request({
    url: "/hq/attendance/getMakeUpPage",
    method: "post",
    data: params
  });
}; //设置经纬度

export var setLangt = function setLangt(params) {
  return request({
    url: "/hq/classroom/setClassRoomPosition",
    method: "post",
    params: params
  });
}; //获取签到详情

export var getRecordInfo = function getRecordInfo(params) {
  return request({
    url: "/hq/attendance/getSelfAttendanceDetails",
    method: "post",
    params: params
  });
}; //我的签到记录分页

export var getMyRecord = function getMyRecord(params) {
  return request({
    url: "/hq/attendance/selfAtendance",
    method: "get",
    params: params
  });
}; //补签确认

export function setToSinIn(query) {
  return request({
    url: "/hq/attendance/signIn",
    method: "post",
    data: query
  });
}